import { TaskEntry } from "./types";

export const getTotalCount = (taskEntries: TaskEntry[]) =>
    taskEntries.reduce((sum, task) => sum + task.count, 0);
